// Accessible-name text for the count badge shown beside "Your actions" and
// on the Home tab (home-page.tsx). Both describe the same `badgeCount`, so
// the string lives in one place rather than as two template literals that
// could quietly drift apart (e.g. one getting pluralised and the other not).
export function actionsBadgeLabel(count: number): string {
  return `${count} action${count === 1 ? "" : "s"} to do`;
}
